import { FormFieldControlled } from "components/UI/FormField/FormFieldControlled";
import { RequestTypeSelect } from "components/UI/RequestTypeSelect";
import { VesselScheduleCheckboxGroupData } from "constants/checkboxGroupData.constants";
import { INPUT_FIELD_NAMES } from "constants/fieldNames.constans";
import { VALIDATION_SCHEMA } from "constants/validationSchema.constans";
import styles from "../index.module.scss";

export const VesselSchedulesAccess = () => {
  return (
    <>
      <div className={styles.wrapperInputs}>
        <FormFieldControlled
          rules={VALIDATION_SCHEMA.toolInfo.required}
          labelTitle="How many searches are you planning to make per month?"
          fieldName={INPUT_FIELD_NAMES.vesselSchedulesSearchesPerMonth}
          className={styles.inputSearches}
        />
        <FormFieldControlled
          rules={VALIDATION_SCHEMA.toolInfo.required}
          labelTitle="How many licenses (subaccounts) do you need?"
          fieldName={INPUT_FIELD_NAMES.vesselSchedulesLicences}
          className={styles.inputLicenses}
        />
      </div>
      <RequestTypeSelect
        rules={VALIDATION_SCHEMA.toolInfo.oneValue}
        fieldName={INPUT_FIELD_NAMES.vesselSchedulessearch_modes}
        label="Which search mode will you use?"
        placeholder="Select search mode"
        options={VesselScheduleCheckboxGroupData}
        className={styles.requestTypeSelect}
      />
    </>
  );
};
